import * as React from 'react'
import { Site } from '@envato/foundation-types'

import FullWidthBannerBlock from '../../../components/categoryPage/fullWidthBannerBlock'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { ICommonLocation } from '../../../../common/utils/location/types'

import * as styles from './fullWidthBannerSection.module.css'

const fullWidthBannerData: any = {
  themeforest: {
    title: '40% off 900+ themes & web templates',
    subtitle: 'Save on best-selling WordPress themes, HTML templates & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#99DBDC',
    textColor: '#191919',
    url:
      'https://themeforest.net/search?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-tf.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  },
  codecanyon: {
    title: '40% off 550+ plugins, scripts & code',
    subtitle: 'Save on best-selling WordPress plugins, PHP scripts & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#FEAC9C',
    textColor: '#191919',
    url: 'https://codecanyon.net/search?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-cc.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  },
  videohive: {
    title: '40% off 850+ video templates',
    subtitle:
      'Save on best-selling After Effects files, Premiere Pro templates & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#BAB2F6',
    textColor: '#191919',
    url: 'https://videohive.net/search?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-vh.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  },
  audiojungle: {
    title: '40% off 1700+ royalty free audio tracks',
    subtitle: 'Save on new and best-selling music, idents & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#FBE16D',
    textColor: '#191919',
    url:
      'https://audiojungle.net/search?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-aj.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  },
  graphicriver: {
    title: '40% off 750+ graphic templates',
    subtitle:
      'Save on best-selling Photoshop actions, presentation templates & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#9AC5FF',
    textColor: '#191919',
    url:
      'https://graphicriver.net/all-graphics?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-gr.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  }
}

const FullWidthBannerSection = ({
  makeSearchLink,
  currentSite,
  location,
  bgColor
}: {
  currentSite: Site
  location: ICommonLocation
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  bgColor: string
}) => {
  if (!fullWidthBannerData[currentSite]) {
    return null
  }
  return (
    <section
      className={styles.fullWidthBannerSectionWrapper}
      style={{ background: bgColor }}
    >
      <div className={styles.fullWidthBannerWrapper}>
        <FullWidthBannerBlock
          location={location}
          locationParams={{}}
          componentType="FullWidthBannerBlock"
          makeSearchLink={makeSearchLink}
          currentSite={currentSite}
          data={fullWidthBannerData[currentSite]}
        />
      </div>
    </section>
  )
}

export default FullWidthBannerSection
